module.exports = __webpack_public_path__ + "img/cryopreservation-vertical-plane-micro-sperm.94bbcb18.png";